import React from 'react';
import PropTypes from 'prop-types';

import V3OfferOriginCard from '../V3OfferOriginCard';
import { isPrimaryOffer } from '../../utils/lineupOrdering';

// The "Template" tile that leads the Simple deal-type grid. It isn't a deal
// type — it's the offer-template picker (Save as new / Change template… /
// Unlink), so the chevron menu is delegated to V3OfferOriginCard, which drives
// all of that off V3OfferContext. The `offer` prop only feeds the subtitle.
//
// O-5024: hidden on the primary offer, whose template is driven by the event
// template control in the header — that applies its offer template to exactly
// this offer, so two controls over one value would contradict each other.
const SimpleTemplateCard = ({ offer }) => {
  const templateName = offer?.template_id ? offer?.template?.name : null;

  if (isPrimaryOffer(offer)) return null;

  return (
    <div className="simple-offer__deal-card simple-offer__deal-card--template" data-testid="simple-template-card">
      <div className="simple-offer__template-card-head">
        <span className="simple-offer__template-card-title">
          <i className="fal fa-th-large" aria-hidden="true" />
          Template
        </span>
        <V3OfferOriginCard />
      </div>
      <span className="simple-offer__deal-card-subtitle">
        {templateName || 'Apply saved offer…'}
      </span>
    </div>
  );
};

SimpleTemplateCard.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number,
    template_id: PropTypes.number,
    template: PropTypes.shape({ name: PropTypes.string }),
    // Read by the primary-offer gate (O-5024).
    lineup: PropTypes.array,
  }),
};

SimpleTemplateCard.defaultProps = { offer: null };

export default SimpleTemplateCard;
